export interface Theme {
  backgroundDark: string;
  backgroundMid: string;
  fontColor: string;
  fontColorSecondary: string;
  onHover: string;
}

export const lightTheme: Theme = {
  backgroundDark: '#050507',
  backgroundMid: 'rgb(202, 202, 202)',
  fontColor: '#333333',
  fontColorSecondary: '#999999',
  onHover: '#00ffbb',
};

export const darkTheme: Theme = {
  backgroundDark: '#050507',
  backgroundMid: '#27272a',
  fontColor: '#ffffff',
  fontColorSecondary: '#999999',
  onHover: '#00ffbb',
};
